import React from 'react'
import { Icon } from './AddAccount.elements'

type Props = {
  className?: string
}

export const AddAccountIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 25 25"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
  >
    <path d="M19.225 8.872v5.99M16.23 11.867h5.99" stroke="currentColor" strokeWidth="1.996"/>
    <circle cx="10.241" cy="8.872" r="3.993" stroke="currentColor" strokeWidth="1.996"/>
    <path d="M17.229 20.85a6.987 6.987 0 10-13.976 0" stroke="currentColor" strokeWidth="1.996"/>
  </Icon>
)
